import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home/Index";
import Login from "./pages/Login/Index";
import Register from "./pages/Register/Index";
import ListCategories from "./pages/Products/ListCategories";
import AddProduct from "./pages/Products/AddProduct";
import Dashboard from "./pages/Dashboard/Index";
import AllProducts from "./pages/Products/AllProducts";
import DailySales from "./pages/Sales/DailySales";
import MonthlySales from "./pages/Sales/MonthlySales";
import Purchase from "./pages/NewPurchase/Index";
import NewSales from "./pages/NewSales/Index";
import SupplierList from "./pages/Supplier/SupplierList";
import TotalSales from "./pages/Sales/TotalSales";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Home />}>
          <Route index element={<Dashboard />} />
          <Route path="/products/all-products" element={<AllProducts />} />
          <Route path="/products/category-list" element={<ListCategories />} />
          <Route path="/products/add-new-product" element={<AddProduct />} />
          <Route path="/sales/daily-sales" element={<DailySales />} />
          <Route path="/sales/monthly-sales" element={<MonthlySales />} />

          <Route path="/sales/daily-sales" element={<DailySales/>} />
          <Route path="/sales/monthly-sales" element={<MonthlySales/>} />
          <Route path="/supplier/supplier-list" element={<SupplierList/>} />
          <Route path="/sales/total-sales" element={<TotalSales/>} />
          <Route path="/supplier/supplier-history" element={<h1>Supplier history</h1>} />
          <Route
            path="/customer/customer-history"
            element={<h1>Cusotmer history</h1>}
          />
          <Route path="/customer/new-sales" element={<NewSales />} />
          <Route path="/purchase" element={<Purchase />} />
          <Route path="/sales-products" element={<h1>Sales Products</h1>} />
          <Route path="/make-a-stuff" element={<h1>Make A Stuff</h1>} />
          <Route path="/settings" element={<h1>Settings</h1>} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
